export function user (state) {
  return state.user
}

export function userId (state, getters) {
  return getters.user?.userId
}

export function username (state, getters) {
  return getters.user?.username
}

export function roles (state, getters) {
  const userRoles = getters.user?.roles ?? []

  if (getters?.company?.isMaster && userRoles.includes('OWNER')) {
    userRoles.push('MASTER')
  }

  return userRoles
}

export function fullname (state, getters) {
  return getters.user
    && `${getters.user.firstName} ${getters.user.lastName}`
}

export function company (state) {
  return state.company
}

export function companyId (state, getters) {
  return getters.company?.id
}

export function companyName (state, getters) {
  return getters.company?.displayName
}

export function companyTokenBalance (state, getters) {
  return getters.company?.tokenBalance
}

export function tokens (state) {
  return state.tokens
}

export function isAuthenticated (state, getters) {
  return !!getters.user && !!getters.tokens
}

export function language (state, getters) {
  return getters?.user?.lang ?? 'en'
}
